(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // keep existing tab & arrow behaviors
  const buttons = document.querySelectorAll('.category-tab-button');
  buttons.forEach(button => {
    button.addEventListener('click', function() {
      const handle = this.dataset.tab;
      showCategoryTab(handle);
    });
  });

  document.querySelectorAll('.category-prev').forEach(button => {
    button.addEventListener('click', function() {
      const handle = this.dataset.handle;
      scrollCategory(handle, -1);
    });
  });
  document.querySelectorAll('.category-next').forEach(button => {
    button.addEventListener('click', function() {
      const handle = this.dataset.handle;
      scrollCategory(handle, 1);
    });
  });

  // --- Auto-scroll setup ---
  const sliders = document.querySelectorAll('.category-product-slider');

  sliders.forEach(slider => {
    try {
      // only enable for sliders with children
      const items = Array.from(slider.children);
      if (!items.length) return;

      // mark as auto-scroll enabled and apply style class
      slider.classList.add('auto-scroll');

      // If not already initialized, duplicate items to create seamless loop
      if (!slider.dataset.loopInitialized) {
        // Clone each visible child but remove interactive elements from clone
        items.forEach(item => {
          const clone = item.cloneNode(true);
          clone.classList.add('clone-item');

          // Remove forms and form controls from the clone to avoid duplicate actions
          // clone.querySelectorAll('form, button, input, select, textarea').forEach(el => el.remove());

          // Remove id attributes to avoid duplicates
          clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));

          // Append clone
          slider.appendChild(clone);
        });

        slider.dataset.loopInitialized = 'true';
      }

      // scrolling speed (pixels per frame) — we will set responsive speed below
      let speed = 0.28;

      // Make speed responsive
      function updateSpeed() {
        const w = window.innerWidth;
        if (w < 640) speed = 0.6;      // mobile a bit faster
        else if (w < 1024) speed = 0.4; // tablet
        else speed = 0.28;             // desktop slower
      }
      updateSpeed();
      window.addEventListener('resize', updateSpeed);

      // control flags
      let paused = false;
      let rafId = null;

      // Pause/resume helpers
      function pause() { paused = true; }
      function resume() { paused = false; }

      // Pause when user interacts: pointer/touch/hover/wheel/mouse
      slider.addEventListener('mouseenter', pause);
      slider.addEventListener('mouseleave', resume);
      slider.addEventListener('pointerenter', pause);
      slider.addEventListener('pointerleave', resume);
      slider.addEventListener('touchstart', pause, { passive: true });
      slider.addEventListener('touchend', resume, { passive: true });

      // Pause briefly when user scrolls with wheel, then resume
      let wheelTimeout;
      slider.addEventListener('wheel', function() {
        pause();
        clearTimeout(wheelTimeout);
        wheelTimeout = setTimeout(resume, 600);
      }, { passive: true });

      // Also pause if user presses mouse down then resume on mouseup
      let mouseDown = false;
      slider.addEventListener('mousedown', function() { mouseDown = true; pause(); });
      document.addEventListener('mouseup', function() { if (mouseDown) { mouseDown = false; resume(); } });

      // Core animation loop using requestAnimationFrame
      function animate() {
        if (!paused) {
          slider.scrollLeft += speed;

          // When reached half of full scrollWidth (we duplicated content), jump back by half for seamless loop
          const half = slider.scrollWidth / 2;
          if (slider.scrollLeft >= half) {
            slider.scrollLeft -= half;
          }
        }
        rafId = requestAnimationFrame(animate);
      }

      // Start loop (cancel if already running)
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(animate);
    } catch (err) {
      console.error('Auto-scroll init error:', err);
    }
  });
});

// keep functions used elsewhere intact
function showCategoryTab(handle) {
  document.querySelectorAll('.category-tab-button').forEach(btn => btn.classList.remove('active'));
  document.querySelectorAll('.category-tab-content').forEach(tab => tab.classList.remove('active'));
  const btn = document.querySelector(`button[data-tab='${handle}']`);
  if (btn) btn.classList.add('active');
  const content = document.getElementById('tab-' + handle);
  if (content) content.classList.add('active');
}

function scrollCategory(handle, direction) {
  const container = document.getElementById('slider-' + handle);
  if (container) {
    container.scrollBy({
      left: 250 * direction,
      behavior: 'smooth'
    });
  }
}
// --- Auto Scroll Loop ---
document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".category-product-slider");

  sliders.forEach(slider => {
    let paused = false;

    // pause when hover
    slider.addEventListener("mouseenter", () => paused = true);
    slider.addEventListener("mouseleave", () => paused = false);

    function loop() {
      if (!paused) {
        slider.scrollLeft += 1; // speed (1px per frame, adjust as needed)

        // if reached end, go back to start
        if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth) {
          slider.scrollLeft = 0;
        }
      }
      requestAnimationFrame(loop);
    }
    loop();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
